module.exports = __webpack_public_path__ + "img/monitor-mobbile.0c2de05d.svg";